// The bootstrap-select library relies on Bootstrap's dropdown plugin. However,
// it needs to have this globally available on the window at window.Dropdown or
// window.bootstrap.Dropdown. By default, Particle exposes bootstrap as a global
// variable if it finds bootstrap as a globally used variable. So basically
// including the bootstrap-select library which uses the bootstrap variable
// globally leads to an inclusion of the whole bootstrap package. This by itself
// is not very efficient, but it also causes issues when importing single
// modules from the bootstrap package like bootstrap/js/src/collapse.js. To
// solve the issue only the dropdown package has been added globally at
// window.Dropdown via webpack.particle.js and all other Bootstrap modules that
// will be used have to be imported as usual.
import 'bootstrap-select';
import $ from 'jquery';
import 'protons';
import './_input.scss';
import './_input.twig';

export const name = 'input';

export const defaults = {};

export function disable() {}

export function enable(context) {
  $('.bootstrap-select', context)
    .selectpicker({
      container: 'body',
      style: 'btn-custom',
      liveSearch: false,
      hideDisabled: true,
      actionsBox: false,
      virtualScroll: false,
      dropupAuto: false,
    })
    .on('loaded.bs.select changed.bs.select', (event) => {
      const $select = $(event.currentTarget);
      const value = $select.val();
      const dropdown = $select.parents('.dropdown').first();
      const hasValue =
        (typeof value === 'string' && value !== '' && value !== '_none') ||
        (Array.isArray(value) && value.length > 0);

      dropdown.toggleClass('dropdown--has-value', hasValue);
    });
}

export default enable;
